import { notify, confirm } from '../../utils/notify';
import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { vendorAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { canAccess } from '../../utils/roles';
import { useListControls, ListToolbar, Pagination } from '../../components/ListControls';
import Topbar from "../../components/Topbar";

const money = n => new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(Number(n)||0);
const CC_OPTIONS = [{code:'CC-001',name:'Civil Works'},{code:'CC-002',name:'Mechanical'},{code:'CC-003',name:'Electrical'},{code:'CC-004',name:'Piping'},{code:'CC-005',name:'Instrumentation'},{code:'CC-006',name:'Structural'},{code:'CC-007',name:'Others'}];

function ProjectCodes() {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({projectCode:'',name:'',description:'',costCenters:[],status:'ACTIVE'});
  const [saving, setSaving] = useState(false);
  
  const [editId, setEditId] = useState(null);

  const load = () => { setLoading(true); vendorAPI.listProjects().then(d=>setProjects(d.projects||[])).catch(()=>{}).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);
  
  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const toggleCC = (cc) => setForm(p=>({ ...p, costCenters: p.costCenters.some(c=>c.code===cc.code) ? p.costCenters.filter(c=>c.code!==cc.code) : [...p.costCenters,cc] }));

  const handleSave = async () => {
    if (!form.projectCode||!form.name) { notify.error('Project code and name are required'); return; }
    setSaving(true);
    try {
      if (editId) await vendorAPI.updateProject(editId, form);
      else await vendorAPI.createProject(form);
      notify.success(editId?'Project updated!':'Project created!');
      setModal(false); setEditId(null); setForm({projectCode:'',name:'',description:'',costCenters:[],status:'ACTIVE'}); load();
    } catch(e) { notify.error(e.message||'Failed'); } finally { setSaving(false); }
  };

  const canManage = canAccess(user, 'vendor.projects');
  const lc = useListControls(projects, { searchFields: ['name', 'projectCode', 'description'], dateField: 'createdAt', pageSize: 10 });

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Vendor Payment" /><section className="container-fluid p-4 pt-3">
        

        <div className="page-hero d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div><h5 className="text-white lh-1">Project Codes</h5><div className="sub">Step 2 — Manage project codes and cost centers for payment tracking</div></div>
          {canManage&&<button onClick={()=>{setForm({projectCode:'',name:'',description:'',costCenters:[],status:'ACTIVE'});setEditId(null);setModal(true);}} className="btn fw-semibold px-4 py-2" style={{background:'rgba(255,255,255,0.2)',color:'#fff',borderRadius:10,border:'1.5px solid rgba(255,255,255,0.35)'}}>
            <i className="bi bi-plus-circle me-2"/>New Project
          </button>}
        </div>

        <div className="row g-2 mb-3">
          {[{l:'Total Projects',v:projects.length,bg:'#eff6ff',ic:'#3b82f6',icon:'bi-kanban'},{l:'Active',v:projects.filter(p=>p.status==='ACTIVE').length,bg:'#f0fdf4',ic:'#22c55e',icon:'bi-check-circle'},{l:'Closed',v:projects.filter(p=>p.status==='CLOSED').length,bg:'#fef2f2',ic:'#ef4444',icon:'bi-x-circle'}].map((s,i)=>(
            <div key={i} className="col-4"><div className="kpi-card d-flex align-items-center gap-2"><div className="kpi-icon" style={{background:s.bg}}><i className={`bi ${s.icon}`} style={{color:s.ic}}/></div><div><div style={{fontSize:'1.17rem',fontWeight:700,lineHeight:1}}>{s.v}</div><div style={{fontSize:'0.7rem',color:'#6b7280',marginTop:2}}>{s.l}</div></div></div></div>
          ))}
        </div>

        {loading?<div className="text-center py-5"><span className="spinner-border text-primary"/></div>
        :projects.length===0?<div className="empty-state"><i className="bi bi-kanban"/><p>No projects found</p></div>
        :(<>
        <ListToolbar search={lc.search} setSearch={lc.setSearch} dateFrom={lc.dateFrom} setDateFrom={lc.setDateFrom} dateTo={lc.dateTo} setDateTo={lc.setDateTo} placeholder="Search by name, project code..." dateLabel="Created"/>
        {lc.paginated.map((p,idx)=>(
          <div key={p._id} className="record-card">
            <div className="record-number">{(lc.page-1)*lc.pageSize+idx+1}.</div>
            <div className="record-body">
              <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                <div style={{fontWeight:700,fontSize:'0.874rem',color:'#111827'}}>{p.name}</div>
                <span className={`status-pill ${p.status==='ACTIVE'?'status-approved':'status-rejected'}`}>{p.status}</span>
                <span style={{background:'#eff6ff',color:'#1d4ed8',fontSize:'0.7rem',padding:'2px 6px',borderRadius:12,fontWeight:600}}>{p.projectCode}</span>
              </div>
              {p.description&&<div style={{fontSize:'0.736rem',color:'#6b7280',marginBottom:8}}>{p.description}</div>}
              <div className="d-flex flex-wrap gap-1">
                {(p.costCenters||[]).map(cc=>(
                  <span key={cc.code} style={{background:'#f3f4f6',color:'#374151',fontSize:'0.7rem',padding:'2px 6px',borderRadius:12,border:'1px solid #e5e7eb'}}>{cc.code} — {cc.name}</span>
                ))}
              </div>
            </div>
            {canManage&&<><div className="divider d-none d-md-block"/>
            <div className="record-actions">
              <button className="btn-card-view" onClick={()=>{setForm({projectCode:p.projectCode,name:p.name,description:p.description||'',costCenters:p.costCenters||[],status:p.status});setEditId(p._id);setModal(true);}}>Edit</button>
            </div></>}
          </div>
        ))}
        <Pagination page={lc.page} totalPages={lc.totalPages} setPage={lc.setPage} totalCount={lc.totalCount} pageSize={lc.pageSize} itemLabel="projects"/>
        </>)}

        {modal&&(
          <div className="modal show d-block" style={{background:'rgba(0,0,0,0.45)'}}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg">
                <div className="modal-header border-0"><h5 className="fw-bold">{editId?'Edit Project':'New Project'}</h5><button className="btn-close" onClick={()=>setModal(false)}/></div>
                <div className="modal-body">
                  <div className="row g-2">
                    <div className="col-md-5"><label className="form-label small fw-semibold">Project Code *</label><input className="form-control" value={form.projectCode} onChange={e=>set('projectCode',e.target.value)} placeholder="PRJ-2025-004" readOnly={!!editId} style={editId?{background:'#f9fafb'}:{}}/></div>
                    <div className="col-md-7"><label className="form-label small fw-semibold">Project Name *</label><input className="form-control" value={form.name} onChange={e=>set('name',e.target.value)}/></div>
                    <div className="col-12"><label className="form-label small fw-semibold">Description</label><textarea className="form-control" rows={2} value={form.description} onChange={e=>set('description',e.target.value)}/></div>
                    <div className="col-md-6"><label className="form-label small fw-semibold">Status</label><select className="form-select" value={form.status} onChange={e=>set('status',e.target.value)}><option>ACTIVE</option><option>CLOSED</option></select></div>
                    <div className="col-12">
                      <label className="form-label small fw-semibold">Cost Centers</label>
                      <div className="d-flex flex-wrap gap-2 mt-1">
                        {CC_OPTIONS.map(cc=>(
                          <label key={cc.code} style={{cursor:'pointer',fontSize:'0.718rem',display:'flex',alignItems:'center',gap:6,padding:'3px 7px',borderRadius:8,background:form.costCenters.some(c=>c.code===cc.code)?'#eff6ff':'#f9fafb',border:`1px solid ${form.costCenters.some(c=>c.code===cc.code)?'#3b82f6':'#e5e7eb'}`,color:form.costCenters.some(c=>c.code===cc.code)?'#1d4ed8':'#6b7280'}}>
                            <input type="checkbox" checked={form.costCenters.some(c=>c.code===cc.code)} onChange={()=>toggleCC(cc)} style={{display:'none'}}/>{cc.code} — {cc.name}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 gap-2">
                  <button className="btn btn-light rounded-3 px-4" onClick={()=>setModal(false)}>Cancel</button>
                  <button className="btn rounded-3 px-5 fw-semibold" style={{background:'linear-gradient(135deg,#1a5276,#1e8449)',color:'#fff',border:'none'}} onClick={handleSave} disabled={saving}>
                    {saving?<span className="spinner-border spinner-border-sm"/>:'Save Project'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section></main></div>
    </>
  );
}
export default ProjectCodes;
